// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Anchor, unionListToAnchor, unionToAnchor} from './anchor.js'

export class CreateComment {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CreateComment {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsCreateComment(bb: flatbuffers.ByteBuffer, obj?: CreateComment): CreateComment {
    return (obj || new CreateComment()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsCreateComment(bb: flatbuffers.ByteBuffer, obj?: CreateComment): CreateComment {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new CreateComment()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  anchorType(): Anchor {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Anchor.NONE
  }

  anchor<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  text(): string | null
  text(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null
  text(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null
  }

  static startCreateComment(builder: flatbuffers.Builder) {
    builder.startObject(3)
  }

  static addAnchorType(builder: flatbuffers.Builder, anchorType: Anchor) {
    builder.addFieldInt8(0, anchorType, Anchor.NONE)
  }

  static addAnchor(builder: flatbuffers.Builder, anchorOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, anchorOffset, 0)
  }

  static addText(builder: flatbuffers.Builder, textOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, textOffset, 0)
  }

  static endCreateComment(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // anchor
    builder.requiredField(offset, 8) // text
    return offset
  }

  static createCreateComment(
    builder: flatbuffers.Builder,
    anchorType: Anchor,
    anchorOffset: flatbuffers.Offset,
    textOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    CreateComment.startCreateComment(builder)
    CreateComment.addAnchorType(builder, anchorType)
    CreateComment.addAnchor(builder, anchorOffset)
    CreateComment.addText(builder, textOffset)
    return CreateComment.endCreateComment(builder)
  }
}
